/**
 * To fix an IE error:
 * http://stackoverflow.com/questions/19321938/invalid-calling-object-error-in-ie
 */
define([], function() {
    'use strict';
    return ({}).toString.call.bind(({}).toString);
});
